import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { AgGridReact } from 'ag-grid-react';

export default class MembershipExpiration extends Component {
    constructor(props) {
        super(props);

        document.title = "Membership Expiration";
        this.state = {
            membershipExpirations: [],
            columnDefs: [
                {
                    field: 'memberName',
                    headerName: 'Member Name',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return (
                            (params.data?.firstName ? params.data.firstName + " " : "") +
                            (params.data?.middleName ? params.data.middleName + " " : "") +
                            (params.data?.lastName ? params.data.lastName : "")
                        )
                    }
                },
                { field: 'name', headerName: 'Board Name', filter: true, floatingFilter: true },
                { field: 'position', headerName: 'Position', filter: true, floatingFilter: true },
                { field: 'title', headerName: 'Title', filter: true, floatingFilter: true },
                {
                    field: 'expiredOn',
                    headerName: 'Expired On',
                    filter: true,
                    floatingFilter: true,
                    valueGetter: (params) => {
                        return params.data?.expirationDate ? new Date(params.data.expirationDate).toLocaleDateString("en-US") : ""
                    }
                }
            ],
            defaultColDef: {
                sortable: true,
                autoHeight: true,
                resizable: true,
                floatingFilter: true
            },
        };
    }

    componentDidMount() {
        fetch('/api/boardmembers/GeExpiredBoardMembers', {
            method: 'GET'
        })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ membershipExpirations: data });
            })
    }

    render() {
        return (
            <div>
                <Alert color='info'>
                    <p className='mb-0'>Below is a list of all expired board members.</p>
                </Alert>
                <br />
                <div style={{ height: "70vh" }}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "100%" }}>
                        <AgGridReact
                            ref={this.gridRef} // Ref for accessing Grid's API
                            rowData={this.state.membershipExpirations} // Row Data for Rows
                            columnDefs={this.state.columnDefs} // Column Defs for Columns
                            defaultColDef={this.state.defaultColDef} // Default Column Properties
                            animateRows={true} // Optional - set to 'true' to have rows animate when sorted or filtered
                            onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                            pagination={true}
                            paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
        )
    }
}